import request from '@/utils/request'
import { UserTable, LoginParams, UserDetailParams, ChangePWD, LoginRes, UserInfo, UserInfoParams } from '@/types/user'
import { SetStoryOnlineParams } from '@/types/manage/tenantStory'
import { qs, foramtParam } from '@/utils/tools'
import { loginUrl } from '@/config/index'

/**
 * 理财师信息
 */
export const fetchUserDetail = (params: UserDetailParams) =>
  request({
    url: '/blackcat/user/detail',
    method: 'get',
    params
  })

export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data
  })

export const login = (data: LoginParams) => {
  const p = qs(data)
  return request({
    url: `/blackcat/login?${p}`,
    method: 'post',
    headers: {
      'Blackcat-Host': loginUrl.replace('https://', '')
    }
  })
}

export const logout = () =>
  request({
    url: '/blackcat/logout',
    method: 'post'
  })
  // 客户查询
export const custormSearch = (params: UserTable) =>
  request({
    url: `/blackcat/customer/page?${qs(params)}`,
    method: 'get'
  })
// 保存客户
export const custormSave = (data: UserTable) =>
  request({
    url: '/blackcat/customer/save',
    method: 'post',
    data
  })

  /**
 * 理财师信息
 */
export const investorInfo = () =>
request({
  url: '/blackcat/advisor/info',
  method: 'get'
})

/**
 * 修改密码
 * @param data:ChangePWD
 */
export const changPwd = (data: ChangePWD) =>
  request({
    url: '/blackcat/account/password/update',
    method: 'post',
    data
  })

/**
 *
 * 头像 上传地址
 */
export const changeAvatarUrl = '/aap/api/v1/blackcat/storage/file/upload'
/**
 * 修改客户信息
 */
export const changeUserInfo = (data: LoginRes | UserInfo) =>
  request({
    url: '/blackcat/account/user/basicinfo/update',
    method: 'post',
    data
  })

/**
 * 添加用户
 */
export const addUser = (data: UserInfo) =>
  request({
    url: '/blackcat/user/save',
    method: 'post',
    data
  })

/**
 * 用户列表
 */
export const fetchUserList = (params: UserInfoParams) => {
  let p: {[propName: string]: any} = {}
  p = Object.assign({}, params)
  p.page = p.page - 1
  return request({
    url: `/blackcat/user/findall?${foramtParam(p)}`,
    method: 'get'
  })
}
/**
 * 用户启用禁用
 */
export const userStatusHandle = (data: any) => {
  return request({
    url: '/blackcat/user/changeflag',
    method: 'post',
    data
  })
}

/**
 * 修改列表客户信息
 */
export const updateListUserInfo = (data: LoginRes | UserInfo) =>
  request({
    url: '/blackcat/user/update',
    method: 'post',
    data
  })

/**
 * 获取用户权限
 */
export const getUserAuth = () =>
  request({
    url: '/blackcat/user/resource',
    method: 'get'
  })

/**
 * 绑定切换许可证
 */
export const registerActivation = (params: any) => {
  return request({
    url: '/blackcat/activation/register',
    method: 'get',
    params
  })
}

/**
 * 是否需要发送手机验证码验证
 */
export const hasPhoneCodeValid = () =>
  request({
    url: `/blackcat/tenant/config`,
    method: 'get',
    headers: {
      'Blackcat-Host': loginUrl.replace('https://', '')
    }
  })

/**
 * 发送手机验证码
 */
export const sendPhoneCode = (code: string) =>
  request({
    url: `/blackcat/sms/send?mobile=${code}`,
    method: 'get',
  })

/**
 * 用户下story列表
 */
export const getUserStory = () => {
  return request({
    url: '/blackcat/story/line/user/list',
    method: 'get',
  })
}
/**
 * 用户story 上下架
 */
export const setUserStoryOnline = (params: SetStoryOnlineParams) => {
  return request({
    url: '/blackcat/story/line/user/online',
    method: 'post',
    data: params
  })
}
/**
 * 当前用户启用故事线
 */
export const storyUserType = (params: {storyLineType: string}) => request({
  url: '/blackcat/story/line/user/type',
  method: 'get',
  params
})

